import { tick } from "svelte";

export function focus(element: HTMLTextAreaElement | HTMLInputElement, focus: boolean = true) {
  if (focus) {
    // tick() is needed here to ensure that the element is fully rendered before it is focused
    tick().then(() => element.focus());
  }
}
